import { render, staticRenderFns } from "./PartnerProfileUpdate.vue?vue&type=template&id=b90a8366&"
import script from "./PartnerProfileUpdate.vue?vue&type=script&lang=ts&"
export * from "./PartnerProfileUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports